module.exports = __webpack_public_path__ + "static/media/triangle.48f872f6.svg";